module.exports = __webpack_public_path__ + "tt.b259be66ef6b25274f1a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tt.svg
// module chunks = styles